import loadable from '@loadable/component';
import React from 'react';
import { LoadingPage } from './LoadingPage';

export const withAsyncLoading = (asyncPageImport: () => Promise<React.ComponentType<any>>) => {
    return loadable(asyncPageImport, { fallback: <LoadingPage /> });
};
